import React from "react";
import "./cit-dashboard.styles.css";
import { Component } from "react";

import API from "../../api";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { setSuggestedDirectFactData } from "../../redux/buying-recommendation/buying-recommendation.actions";
import { selectSuggestedDirectFactData } from "../../redux/buying-recommendation/buying-recommendation.selectors";
import { selectUserData } from "../../redux/user/user.selectors";
import {
  Table,
  Spin,
  message,
  Button,
  Checkbox,
  Input,
  Typography,
  Row,
  Col,
  Card,
  Dropdown,
  Icon,
  Menu,
  PageHeader,
  Select,
} from "antd";
import {
  setCitData,
  setScreen,
} from "../../redux/commodity-intelegence-tower/commodity-intelegence-tower.actions";

const { Option } = Select;

/**
 *
 * @classdesc The Buying reccomendation tab component.
 * @description Displays a table containing the daily output from the modal
 * @component
 */
class CITDashboard extends Component {
  state = {
    isSpinnerOnTable: true,
    date: "",
    time: "",
    cropLists: [],
  };

  /**
   * @function
   * @description Wait until the user logs in so that a valid access token is generated
   * to call the get api for daily recommentation data.
   * @memberof DownloadReport
   */
  waitUntilLogin = () => {
    if (localStorage.getItem("accessToken") != null) {
      this.setState({ isSpinnerOnTable: true });
      API.get("/cit-crop").then((response) => {
        console.log("croplists", response);
        this.setState({
          cropLists: response.data.data,
        });
      });
      this.setState({
        isSpinnerOnTable: false,
      });
    } else {
      setTimeout(() => this.waitUntilLogin(), 100);
    }
  };

  componentDidMount() {
    this.waitUntilLogin();
  }

  render() {
    const ConfigOptions = {
      maxCount: 1,
    };
    message.config(ConfigOptions);
    const data = [
      "Wheat",
      "Paddy",
      "Maize",
      "Chana",
      "Soybean",
      "Mustard",
      "Chilly",
      "Turmeric",
      "Cumin",
      "Coriander",
      "Coffee",
      "Aqua",
    ];
    //#endregion
    const handleChange = (pagination, filters, sorter) => {
      // this.setState({ filteredInfo: filters });
    };
    return (
      <div
        className="cit-container"
        style={{ height: window.innerHeight - 83 }}
      >
        <div className="dashboard">
          <PageHeader
            title="Commodity Intelligence Tower"
            className="cit-header"
          />
          <Row>
            <Col span={16}>
              <Row>
                {this.state.cropLists &&
                  this.state.cropLists.map((item) => {
                    return (
                      <Col
                        span={5}
                        offset={1}
                        key={item.crop_id}
                        className="item-col"
                      >
                        <Button
                          className="item-btn"
                          onClick={() => {
                            this.props.setCitData(item);
                            this.props.setScreen(1);
                          }}
                        >
                          {item.crop_name}
                        </Button>
                      </Col>
                    );
                  })}
              </Row>
            </Col>
            <Col span={7} offset={1}>
              <Spin spinning={this.state.isSpinnerOnTable}>
                <Card className="cit-card" style={{ width: 250 }}>
                  <h1>Commodity Repositories</h1>
                  <p>
                    <Select
                      defaultValue={
                        this.state.cropLists.length > 0 &&
                        this.state.cropLists[0]?.crop_id
                      }
                      style={{ width: "100%" }}
                      onChange={handleChange}
                      className="cit-select"
                    >
                      {this.state.cropLists &&
                        this.state.cropLists.map((item) => {
                          return (
                            <Option value={item.crop_id} key={item.crop_id}>
                              {item.crop_name}
                            </Option>
                          );
                        })}
                    </Select>
                  </p>
                  <p>
                    <Button
                      type="primary"
                      style={{
                        width: "100%",
                      }}
                      onClick={() => {
                        console.log("upload");
                      }}
                    >
                      Upload File
                    </Button>
                  </p>
                  <p>
                    <Button
                      type="primary"
                      style={{
                        width: "100%",
                        maxHeight: "",
                      }}
                      onClick={() => {
                        console.log("download");
                      }}
                    >
                      Download File
                    </Button>
                  </p>
                </Card>
              </Spin>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setScreen: (data) => dispatch(setScreen(data)),
    setCitData: (data) => dispatch(setCitData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CITDashboard);
